import { Route, Routes } from "react-router-dom";
import CompanyMonitoring from "pages/monitoring/company";
import CompanyViewMonitoring from "pages/monitoring/company-view";
import RouteAccessError from "pages/RouteAccessError";
import PermissionRoute from "components/route/PermissionRoute";
import { PERMISSIONS } from "config/permissions";

export default function MonitoringCompanyRoutes(props) {

    return (
        <Routes>
            <Route path="/">
                <Route
                    index
                    element={
                        <PermissionRoute
                            permission={PERMISSIONS.FRONT_READ}
                        >
                            <CompanyMonitoring />
                        </PermissionRoute>
                    }
                />
                <Route path=":id" 
                    element={ 
                        <PermissionRoute
                            permission={PERMISSIONS.FRONT_READ}
                        >
                            <CompanyViewMonitoring />
                        </PermissionRoute> 
                    }
                 />
                <Route path="*" element={ <RouteAccessError /> }/>
            </Route>
        </Routes>
    );
}